import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Base/Home'
// import Settings from '@/components/Setting/Settings'
// import Nuclei from '@/components/Nucleus/Nuclei'
// import Alarms from '@/components/Alarm/Alarms'
// import Readings from '@/components/Reading/Readings'
// import Statistics from '@/components/Statistic/Statistics'
// import Countries from '@/views/Country/Countries'
// import States from '@/views/State/States'
// import Cities from '@/views/City/Cities'
// import Sexes from '@/views/Sex/Sexes'
// import Devices2 from '@/views/Device/Devices2'
// import DeviceModels from '@/views/Device/DeviceModels'
// import DeviceTypes from '@/views/Device/DeviceTypes'
// import Mortalities from '@/views/Batch/Mortalities'
// import Walls from '@/views/Wall/Walls'
// import Floors from '@/views/Floor/Floors'
// import Roofs from '@/views/Roof/Roofs'
// import InnerCurtains from '@/views/InnerCurtain/InnerCurtains'
// import OuterCurtains from '@/views/OuterCurtain/OuterCurtains'
// import Linings from '@/views/Lining/Linings'
// import EvaporativePlates from '@/views/EvaporativePlate/EvaporativePlates'
// import LightingSystems from '@/views/LightingSystem/LightingSystems'
// import InternetAccessTypes from '@/views/InternetAccessType/InternetAccessTypes'
// import Barns from '@/views/Barn/Barns'
// import BarnTypes from '@/views/BarnType/BarnTypes'
// import VoltageTypes from '@/views/VoltageType/VoltageTypes'
// import AirInlets from '@/views/AirInlet/AirInlets'
// import SiloTypes from '@/views/SiloType/SiloTypes'
// import WaterBoxes from '@/views/WaterBox/WaterBoxes'
// import WatchdogSystems from '@/views/WatchdogSystem/WatchdogSystems'
// import BatchStates from '@/views/BatchState/BatchStates'
// import Manufacturers from '@/views/Manufacturer/Manufacturers'
// import Accounts from '@/views/Account/Accounts'
// import Nuclei2 from '@/views/Nucleus2/Nuclei2'
// import Ownships from '@/views/Ownship/Ownships'
// import Readings2 from '@/views/Reading2/Readings2'

// import AlertSettings from '@/components/Alert/AlertSettings'
// import AlertHistory from '@/components/Alert/AlertHistory'
// import Users from '@/components/User/Users'
// import Profile from '@/components/Auth/Profile'
import authGuard from './auth-guard'
import alarmsGuard from './alarms-guard'
import birdWeightGuard from './bird-weight-guard'
import aeiGuard from './aei-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/Base/Home'),
      beforeEnter: authGuard,
      children: [
        {
          path: 'dashboard',
          component: () => import('@/components/Dashboard/DashboardView')
        },
        {
          path: 'settings',
          component: () => import('@/components/Setting/Settings')
        },
        {
          path: 'devices',
          component: () => import('@/components/Device/Devices')
        },
        {
          path: 'nuclei',
          component: () => import('@/components/Nucleus/Nuclei')
        },
        {
          path: 'properties',
          redirect: '/dashboard'
        },
        {
          path: 'alarms',
          component: () => import('@/views/Alarm/AlarmsDashboard'),
          beforeEnter: alarmsGuard
        },
        {
          // The notification history is now a tab of the alarms page; kept so
          // older links (and the notification id they carry) keep working.
          path: 'notifications',
          redirect: to => ({ path: '/alarms', query: Object.assign({}, to.query, { tab: 'notifications' }) })
        },
        {
          path: 'bird-weight',
          component: () => import('@/views/BirdWeight/BirdWeightDashboard'),
          beforeEnter: birdWeightGuard
        },
        {
          path: 'bird-weight/:barnId/:batchId?',
          component: () => import('@/views/BirdWeight/BirdWeightDetail'),
          beforeEnter: birdWeightGuard,
          props: true
        },
        {
          path: 'aei/dashboard',
          component: () => import('@/views/Aei/AeiDashboard'),
          beforeEnter: aeiGuard
        },
        {
          path: 'aei/feed-bins',
          component: () => import('@/views/Aei/AeiFeedBinsDashboard'),
          beforeEnter: aeiGuard
        },
        {
          path: 'aei/houses',
          component: () => import('@/views/Aei/AeiHousesDashboard'),
          beforeEnter: aeiGuard
        },
        {
          path: 'aei/houses/:deviceId',
          component: () => import('@/views/Aei/AeiHouseDetail'),
          beforeEnter: aeiGuard,
          props: true
        },
        {
          path: 'aei/processing',
          component: () => import('@/views/Aei/AeiProcessingDashboard'),
          beforeEnter: aeiGuard
        },
        {
          path: 'readings',
          component: () => import('@/components/Reading/Readings')
        },
        {
          path: 'statistics',
          component: () => import('@/components/Statistic/Statistics')
        },
        {
          path: 'countries',
          component: () => import('@/views/Country/Countries')
        },
        {
          path: 'states',
          component: () => import('@/views/State/States')
        },
        {
          path: 'cities',
          component: () => import('@/views/City/Cities')
        },
        {
          path: 'sexes',
          component: () => import('@/views/Sex/Sexes')
        },
        {
          path: 'deviceModels',
          component: () => import('@/views/Device/DeviceModels')
        },
        {
          path: 'deviceTypes',
          component: () => import('@/views/Device/DeviceTypes')
        },
        {
          path: 'mortalities',
          component: () => import('@/views/Mortality/Mortalities')
        },
        {
          path: 'walls',
          component: () => import('@/views/Wall/Walls')
        },
        {
          path: 'floors',
          component: () => import('@/views/Floor/Floors')
        },
        {
          path: 'roofs',
          component: () => import('@/views/Roof/Roofs')
        },
        {
          path: 'innerCurtains',
          component: () => import('@/views/InnerCurtain/InnerCurtains')
        },
        {
          path: 'outerCurtains',
          component: () => import('@/views/OuterCurtain/OuterCurtains')
        },
        {
          path: 'ownships',
          component: () => import('@/views/Ownship/Ownships')
        },
        {
          path: 'linings',
          component: () => import('@/views/Lining/Linings')
        },
        {
          path: 'evaporativePlates',
          component: () => import('@/views/EvaporativePlate/EvaporativePlates')
        },
        {
          path: 'lightingSystems',
          component: () => import('@/views/LightingSystem/LightingSystems')
        },
        {
          path: 'internetAccessTypes',
          component: () => import('@/views/InternetAccessType/InternetAccessTypes')
        },
        {
          path: 'barns',
          component: () => import('@/views/Barn/Barns')
        },
        {
          path: 'barnTypes',
          component: () => import('@/views/BarnType/BarnTypes')
        },
        {
          path: 'voltageTypes',
          component: () => import('@/views/VoltageType/VoltageTypes')
        },
        {
          path: 'airInlets',
          component: () => import('@/views/AirInlet/AirInlets')
        },
        {
          path: 'siloTypes',
          component: () => import('@/views/SiloType/SiloTypes')
        },
        {
          path: 'waterBoxes',
          component: () => import('@/views/WaterBox/WaterBoxes')
        },
        {
          path: 'watchdogSystems',
          component: () => import('@/views/WatchdogSystem/WatchdogSystems')
        },
        {
          path: 'batches',
          component: () => import('@/views/Batch/Batches')
        },
        {
          path: 'batchStates',
          component: () => import('@/views/BatchState/BatchStates')
        },
        {
          path: 'manufacturers',
          component: () => import('@/views/Manufacturer/Manufacturers')
        },
        {
          path: 'account',
          component: () => import('@/views/Account/Accounts')
        },
        {
          path: 'nuclei2',
          component: () => import('@/views/Nucleus2/Nuclei2')
        },
        {
          path: 'devices2',
          component: () => import('@/views/Device/Devices2')
        },
        {
          path: 'readings2',
          component: () => import('@/views/Reading2/Readings2')
        },
        {
          path: 'temperatureChart',
          component: () => import('@/views/Reading2/ReadingsTemperatureChart')
        },
        {
          path: 'humidityChart',
          component: () => import('@/views/Reading2/ReadingsHumidityChart')
        },
        {
          path: 'waterChart',
          component: () => import('@/views/Reading2/ReadingsWaterChart')
        },
        {
          path: 'co2Chart',
          component: () => import('@/views/Reading2/ReadingsCO2Chart')
        },
        {
          path: 'readingsMultipleYaxis',
          component: () => import('@/views/Reading2/ReadingsMultipleYaxis')
        },
        {
          path: 'readingsPie',
          component: () => import('@/views/Reading2/ReadingsPieChart')
        },
        {
          path: 'readingsRadar',
          component: () => import('@/views/Reading2/ReadingsRadarChart')
        },
        {
          path: 'readingsHeatMap',
          component: () => import('@/views/Reading2/ReadingsHeatMapChart')
        },
        {
          path: 'readingsCustomBar',
          component: () => import('@/views/Reading2/ReadingsCustomBarChart')
        },
        {
          path: 'readingsRealtime',
          component: () => import('@/views/Reading2/ReadingsRealtimeChart')
        },
        {
          path: 'readingsCandleStickChart',
          component: () => import('@/views/Reading2/ReadingsCandleStickChart')
        },
        {
          path: 'readingsChartZoomable',
          component: () => import('@/views/Reading2/ReadingsChartZoomable')
        },
        {
          path: 'readingsHorizontalBar',
          component: () => import('@/views/Reading2/ReadingsHorizontalBarChart')
        },
        {
          path: 'readingsRealLineChart',
          component: () => import('@/views/Reading2/ReadingsRealLineChart')
        },
        {
          path: 'waterConsumptionChart',
          component: () => import('@/views/Reading2/WaterConsumptionChart')
        },
        {
          path: 'charts',
          component: () => import('@/views/Chart/Charts')
        }
        // {
        //   path: 'users',
        //   component: Users
        // }
        // {
        //   path: 'profile',
        //   component: Profile
        // },
        // {
        //   path: 'alert/settings',
        //   name: 'AlertSettings',
        //   component: AlertSettings,
        // },
        // {
        //   path: 'alert/history',
        //   name: 'AlertHistory',
        //   component: AlertHistory,
        // }
      ]
    },
    {
      path: '/signin',
      name: 'Signin',
      component: () => import('@/components/Auth/Signin')
    },
    // Google Play's account deletion link (IND-2198). Kept outside Home so
    // neither page carries the premium plan banner: the first one is public,
    // the second only needs a signed-in user.
    {
      path: '/delete-account',
      name: 'AccountDeletion',
      component: () => import('@/views/AccountDeletion/AccountDeletion')
    },
    {
      path: '/delete-account/confirm',
      name: 'AccountDeletionConfirm',
      component: () => import('@/views/AccountDeletion/AccountDeletionConfirm'),
      beforeEnter: authGuard
    },
    // {
    //   path: '/signup',
    //   // path: '/signupkeepitprivate',
    //   name: 'Signup',
    //   component: () => import('@/components/Auth/Signup')
    // },
    {
      path: '*',
      redirect: '/'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js